import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalConstants } from '@globalConstants';
import { IAppState } from '@myStore/app.state';
import { selectTheme } from '@myStore/theme/theme.selector';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class DialogData {
  panelClass?: string;
  title!: string;
  content!: never | null;
  id?: number;
}
@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.sass'],
})
export class InfoDialogComponent implements OnInit, OnDestroy {
  public UIThemes = GlobalConstants.UIThemes;
  public theme: string = this.UIThemes.light;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    private _store: Store<IAppState>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this._store
      .pipe(select(selectTheme), takeUntil(this.destroy$))
      .subscribe(theme => {
        this.theme = theme;
        const panelClass = this.dialogRef.componentInstance?.data.panelClass;

        if (theme === this.UIThemes.dark) {
          this.dialogRef.addPanelClass('custom-modal');
        }

        if (theme === this.UIThemes.dark && panelClass) {
          this.dialogRef.addPanelClass(panelClass);
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
